import Vue from 'vue' ;
import Vuex from 'vuex' ;
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex) ;

export default new Vuex.Store({
  // strict: true,
  plugins: [createPersistedState()],

  state: {
    token: null,
    user: null,
    loggedIn: false,
    isEditor: false,
    isAdmin: false,
    pendingMessage: null  // props: text, color
  },

  mutations: {
    setUserAndToken (state, userAndToken) {
      if (userAndToken) {
        state.user = userAndToken.user ;
        state.token = userAndToken.token ;
      }
      else {
        state.user = null ;
        state.token = null ;
      }

      if (state.token && state.user) {
        state.loggedIn = true ;
        state.isEditor = (state.user.auth && (state.user.auth.includes("editor"))) ;
        state.isAdmin = (state.user.auth && (state.user.auth.includes("admin"))) ;
      }
      else {
        state.loggedIn = false ;
        state.isEditor = false ;
        state.isAdmin = false ;
      }
    },
    setPendingMessage (state, pendingMessage) {
      state.pendingMessage = pendingMessage ;
    }
  },

  actions: {
    setUserAndToken ({commit}, userAndToken) {
      commit('setUserAndToken', userAndToken) ;
    },
    setPendingMessage ({commit}, pendingMessage) {
      commit('setPendingMessage', pendingMessage) ;
    },
    clearPendingMessage ({commit}) {
      commit('setPendingMessage', null) ;
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js